import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo/Transprant.png';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img 
          src={logo} 
          alt="7BOX Logo" 
          style={{ height: '30px', width: 'auto' }}
        />
        {/* <span>7BOX</span> */}
      </div>
      <div className="links">
        <Link to="/">Home</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/delete-account">Delete Account</Link>
      </div>
    </nav>
  );
}

export default Navbar;

